import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import DetalheInscricao from './components/DetalheInscricao';

const Inscricao = (props) => (
  <Container>
    <Row>
      <Col md={12}>
        <h3 className="page-title">Detalhes da Inscrição</h3>
        <h3 className="page-subhead subhead">
          Verifique as situação da sua inscrição e seus pagamentos.
        </h3>
      </Col>
    </Row>
    <Row>
      <DetalheInscricao props={props} />
    </Row>
  </Container>
);

export default Inscricao;
